import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';

const Container = styled.div``;

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class WS2_10_ExteriorPicturesComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        <VehicleHeader vehicle={this.vehicle} />

        <Well>{this.props.column.label} Voltooid?</Well>
        <ModalControls>
          <PerformActionButton action={this.props.action} target={this.vehicle} onChange={this.reset.bind(this)} />
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

WS2_10_ExteriorPicturesComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const WS2_10_ExteriorPictures = compose(
  withConnect,
  withRouter,
)(WS2_10_ExteriorPicturesComp);
